import React, { useEffect, useState } from 'react';
import {
    Users,
    Crown,
    Shield,
    UserCheck,
    Search,
    ChevronRight,
    Award,
    Building2,
    Briefcase,
    MapPin,
    X
} from 'lucide-react';

// Structure des données de l'organigramme
const ORGANIGRAMME_DATA = {
    vicePresidents: [
        { nom: "Aurélie NTOUTOUME", genre: "F" },
        { nom: "Elodie Diane FOUEFOUE", genre: "F" },
        { nom: "Séraphin AKURE DAVIN", genre: "M" },
        { nom: "Serge Maurice MABIALA", genre: "M" },
        { nom: "Ulrich MANFOUMBI MANFOUMBI", genre: "M" },
        { nom: "Germain BIAHODJOW", genre: "M" },
        { nom: "Armande LONGO Epse MOULENGUI", genre: "F" },
        { nom: "Régis ONANGA NDIAYE", genre: "M" },
        { nom: "Maurice NTOSSUI", genre: "M" },
        { nom: "Firmin NGUEMA", genre: "M" }
    ],
    conseilStrategique: {
        "Estuaire": ["Paul BIYOGHE MBA", "Victorine TCHICOT", "Charles OREZANS"],
        "Haut-Ogooué": ["Cyrielle SENDE", "Alexandre AWASSI", "Brice LACRUCHE ALIHANGA"],
        "Moyen-Ogooué": ["Emmanuel BIYE", "Joel OGOUMA", "Nadine OGOULA"],
        "Ngounié": ["Guy Bertrand MAPANGOU", "Steeve DELBRA DJOTA DJOTA", "Marcelle ITSITSA"],
        "Nyanga": ["Séraphin MOUNDOUNGA", "Béni NGOUA MBINA", "Zora KASSA"],
        "Ogooué-Ivindo": ["Philippe TONANGOYE", "Marie Nadège EDJE BABI Epse BOULINGUI", "Simplice NTEME"],
        "Ogooué-Lolo": ["Huguette TSONO", "Eric MOUELE", "Jérémy MIKOMBO"],
        "Ogooué-Maritime": ["Bourdes OLIWINA", "Jean Blaise NGUIMBI", "Donatien RASSIKIMIA"],
        "Woleu-Ntem": ["Lubin NTOUTOUME", "Diane MENGUE", "Bertrand ZIBI ABEGHE"],
        "Diaspora": ["Jean Aimé MOUKETOU", "Prince Arsène MENIE", "Léa Ukelle NZIENGUI MABILA"]
    },
    secretariat: {
        general: { nom: "Mays MOUISSI", poste: "Secrétaire Général" },
        adjoints: [
            { nom: "Eloi NZONDO", poste: "Secrétaire Général Adjoint - Chargé de la stratégie et de l'idéologie" },
            { nom: "Madeleine REVENGUE", poste: "Secrétaire Général Adjoint - Chargé de la Coordination des élus du parti" },
            { nom: "Charles Henri GEY", poste: "Secrétaire Général Adjoint - Chargé de l'implantation et de la coordination des structures locales et extérieures" },
            { nom: "Sosthène NGUEMA NGUEMA", poste: "Secrétaire Général Adjoint - Chargé du Suivi Evaluation des Politiques Publiques" },
            { nom: "Parfaite AMOUYEME OLLAME", poste: "Secrétaire Général Adjoint - Chargé de la Communication, du Numérique et de la Veille Stratégique (Porte-parole)" },
            { nom: "Mesmin NGABIKOUMOU WADA", poste: "Secrétaire Général Adjoint - Chargé des Elections" },
            { nom: "Jonathan IGNOUMBA", poste: "Secrétaire Général Adjoint - Chargé des Relations avec les Autres Partis, Associations et Syndicats" },
            { nom: "Leon ABABE", poste: "Secrétaire Général Adjoint - Chargé des Institutions et des Relations Internationales" },
            { nom: "Raissa NANA", poste: "Secrétaire Général Adjoint - Chargé des Affaires Juridiques, Administratives, Discipline et Contentieux" }
        ]
    },
    tresorerie: {
        general: { nom: "Aurélien - Marcel MINTSA NGUEMA", poste: "Trésorier Général" },
        adjoints: [
            { nom: "Christiane MARAT GNANGUE", poste: "Trésorier Général Adjoint 1" },
            { nom: "Yannick MEFANE", poste: "Trésorier Général Adjoint 2" }
        ]
    },
    delegations: {
        "Estuaire": "Julien ASSOUMOU AKOUE",
        "Haut-Ogooué": "Judith Justine LEKOGO",
        "Moyen-Ogooué": "Paul KESSANY",
        "Ngounié": "PR Adrien MOUGOUGOU",
        "Nyanga": "Jean Pierre DOUKAGA KASSA",
        "Ogooué-Ivindo": "Guy Roger EKAZAMA",
        "Ogooué-Lolo": "Jean Bosco MBAGOU",
        "Ogooué-Maritime": "Virginie ETENO",
        "Woleu-Ntem": "Emmanuel EYEGHE NZE"
    },
    cabinet: {
        directeur: { nom: "JEAN PIERRE OYIBA", poste: "Directeur de Cabinet Politique" },
        adjoints: [
            { nom: "Albert Richard ROYEMBO", poste: "Directeur de Cabinet Politique Adjoint 1" },
            { nom: "Joelle ONA", poste: "Directeur de Cabinet Politique Adjoint 2" }
        ],
        rapporteurs: [
            { nom: "Freddy IKABANGA NGOYE MALOUMBI", poste: "Rapporteur Général" },
            { nom: "Tita Michel EDOU NGOMO", poste: "Rapporteur Général Adjoint 1" },
            { nom: "Sophie ESSONGHE", poste: "Rapporteur Général Adjoint 2" }
        ],
        secretaires: [
            { nom: "Lucie MOULILI KOKA", poste: "Secrétaire Particulière" },
            { nom: "Nelly Flora ZOLOME", poste: "Secrétaire de Cabinet" },
            { nom: "Daisy AKINI KOUSSOU", poste: "Secrétaire de Cabinet Adjoint" }
        ]
    },
    conseillers: [
        { nom: "Nicolas NGUEMA", specialite: "Chargé de la Coordination des élus du parti" },
        { nom: "Carl MIHINDOU - MI- NZAMBE", specialite: "Chargé de l'Implantation et de la coordination des structures locales et extérieures" },
        { nom: "Luck ONDIAS SOUNA", specialite: "Chargé de Communication, du Numérique et de la Veille Stratégique" },
        { nom: "Célestine BA OGOUEWA", specialite: "Chargé des Elections" },
        { nom: "Alexi NNANG NTSEME", specialite: "Chargé des Affaires Juridiques, Administratives, Discipline et Contentieux" },
        { nom: "Claire NEWMAN", specialite: "Chargé des Relations avec les Autres Partis, Associations et Syndicats" },
        { nom: "Nadine AWANANG", specialite: "Chargé des Institutions et des Relations Internationales" },
        { nom: "Frédéric MASSAVALA", specialite: "Chargé de la Stratégie et de l'idéologie" },
        { nom: "Simplice MOUANGO", specialite: "Chargé du Suivi Evaluation des Politiques Publiques" },
        { nom: "Rodrigue BOKOKO", specialite: "Chargé de la Mobilisation" }
    ]
};

const OrganigrammePage: React.FC = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [expandedSections, setExpandedSections] = useState<Set<string>>(new Set(['vicePresidents']));
    const [visibleSections, setVisibleSections] = useState<Set<string>>(new Set());

    useEffect(() => {
        // Scroll vers le haut au chargement
        window.scrollTo(0, 0);

        // Animation progressive des sections
        const sections = ['vicePresidents', 'conseilStrategique', 'secretariat', 'tresorerie', 'delegations', 'cabinet', 'conseillers'];
        const timer = setTimeout(() => {
            sections.forEach((section, index) => {
                setTimeout(() => {
                    setVisibleSections(prev => {
                        const newSet = new Set(prev);
                        newSet.add(section);
                        return newSet;
                    });
                }, index * 100);
            });
        }, 300);

        return () => clearTimeout(timer);
    }, []);

    const toggleSection = (sectionId: string) => {
        setExpandedSections(prev => {
            const newSet = new Set(prev);
            if (newSet.has(sectionId)) {
                newSet.delete(sectionId);
            } else {
                newSet.add(sectionId);
            }
            return newSet;
        });
    };

    // Fonction de recherche
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const searchInText = (text: string, term: string): boolean => {
        return text.toLowerCase().includes(term.toLowerCase());
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const filterBySearch = (data: any, searchTerm: string): boolean => {
        if (!searchTerm.trim()) return true;

        const term = searchTerm.toLowerCase();

        if (typeof data === 'string') {
            return data.toLowerCase().includes(term);
        }

        if (typeof data === 'object' && data !== null) {
            if (data.nom) {
                return data.nom.toLowerCase().includes(term);
            }
            if (data.poste) {
                return data.poste.toLowerCase().includes(term);
            }
            if (data.specialite) {
                return data.specialite.toLowerCase().includes(term);
            }
        }

        return false;
    };

    // Détection du genre
    const detectGender = (nom: string): 'F' | 'M' => {
        const femaleNames = ['Aurélie', 'Elodie', 'Armande', 'Victorine', 'Cyrielle', 'Nadine', 'Marcelle', 'Zora', 'Marie', 'Huguette', 'Diane', 'Léa', 'Madeleine', 'Parfaite', 'Raissa', 'Christiane', 'Judith', 'Virginie', 'Joelle', 'Sophie', 'Lucie', 'Nelly', 'Daisy', 'Célestine', 'Claire'];

        if (nom.includes('Epse')) return 'F';

        for (const femaleName of femaleNames) {
            if (nom.includes(femaleName)) return 'F';
        }

        return 'M';
    };

    // Calcul des statistiques
    const stats = {
        totalVicePresidents: ORGANIGRAMME_DATA.vicePresidents.length,
        femmeVicePresidents: ORGANIGRAMME_DATA.vicePresidents.filter(vp => vp.genre === 'F').length,
        totalConseilStrategique: Object.values(ORGANIGRAMME_DATA.conseilStrategique).reduce((acc, arr) => acc + arr.length, 0),
        totalSecrétaires: 1 + ORGANIGRAMME_DATA.secretariat.adjoints.length,
        totalDélégations: Object.keys(ORGANIGRAMME_DATA.delegations).length,
        totalConseillers: ORGANIGRAMME_DATA.conseillers.length
    };

    // Composant card moderne et uniforme pour tous
    const UniformPersonCard: React.FC<{nom: string, poste?: string, specialite?: string, isLeader?: boolean}> =
        ({nom, poste, specialite, isLeader = false}) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const isWoman = detectGender(nom) === 'F';
            const initials = nom.split(' ').slice(0, 2).map(n => n.charAt(0)).join('');

            return (
                <div className="group relative bg-white hover:bg-gray-50/50 transition-all duration-500 ease-out">
                    {/* Ligne accent subtile en haut */}
                    <div className={`h-0.5 w-full ${isLeader ? 'bg-gradient-to-r from-primary-blue via-primary-green to-primary-yellow' : 'bg-gray-200'} transition-all duration-300`} />

                    {/* Contenu principal */}
                    <div className="p-6 relative">
                        {/* Badge de leadership minimaliste */}
                        {isLeader && (
                            <div className="absolute top-4 right-4">
                                <div className="w-2 h-2 bg-primary-yellow shadow-sm" />
                            </div>
                        )}

                        <div className="flex items-start space-x-4">
                            {/* Avatar moderne taille moyenne - tout le monde en bleu */}
                            <div className="flex-shrink-0 relative">
                                <div className="w-16 h-16 bg-gradient-to-br from-blue-50 to-blue-100 text-blue-600 flex items-center justify-center relative group-hover:scale-105 transition-all duration-300">
                                    <span className="text-lg font-light tracking-wide">{initials}</span>
                                </div>

                                {/* Indicateur de statut moderne - tout le monde en bleu */}
                                <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-blue-400 flex items-center justify-center">
                                    <div className="w-1.5 h-1.5 bg-white" />
                                </div>
                            </div>

                            {/* Contenu textuel moderne */}
                            <div className="flex-1 min-w-0 space-y-2">
                                {/* Nom avec typography moderne */}
                                <h4 className="text-lg font-light text-gray-900 group-hover:text-primary-blue transition-colors duration-300 leading-tight">
                                    {nom}
                                </h4>

                                {/* Poste directement sous le nom */}
                                {poste && (
                                    <p className="text-gray-600 font-medium text-sm">
                                        {poste}
                                    </p>
                                )}

                                {/* Spécialité si présente */}
                                {specialite && (
                                    <p className="text-gray-500 text-xs font-light">
                                        {specialite}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Effet de hover subtil et moderne */}
                    <div className="absolute inset-0 border border-transparent group-hover:border-gray-200/50 transition-all duration-300 pointer-events-none" />

                    {/* Glow effect très subtil */}
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary-blue/20 to-transparent" />
                        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary-green/20 to-transparent" />
                    </div>
                </div>
            );
        };

    // Composant card standard - maintenant identique
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const StandardPersonCard: React.FC<{nom: string, poste?: string, specialite?: string, isLeader?: boolean}> =
        ({nom, poste, specialite, isLeader = false}) => {
            // Utilise exactement le même composant que les VIP
            return <UniformPersonCard nom={nom} poste={poste} specialite={specialite} isLeader={isLeader} />;
        };

    // Fonction pour rendre une section
    const renderSection = (
        sectionId: string,
        title: string,
        icon: React.ReactNode,
        content: React.ReactNode,
        description?: string
    ) => {
        const isExpanded = expandedSections.has(sectionId);
        const isVisible = visibleSections.has(sectionId);

        return (
            <div
                className={`transition-all duration-700 ${
                    isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
            >
                <div className="bg-white border border-gray-300 mb-6">
                    <div
                        className="p-6 cursor-pointer hover:bg-gray-50 transition-colors border-l-4 border-l-primary-green"
                        onClick={() => toggleSection(sectionId)}
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-4">
                                <div className="w-12 h-12 bg-primary-green text-white flex items-center justify-center border border-gray-400">
                                    {icon}
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-gray-900">{title}</h3>
                                    {description && <p className="text-gray-600 mt-1">{description}</p>}
                                </div>
                            </div>
                            <ChevronRight
                                className={`w-6 h-6 text-gray-400 transition-transform duration-300 ${
                                    isExpanded ? 'rotate-90' : ''
                                }`}
                            />
                        </div>
                    </div>

                    {isExpanded && (
                        <div className="p-6 border-t border-gray-300">
                            {content}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    // Filtrage pour la recherche
    const getFilteredResults = () => {
        if (!searchTerm.trim()) {
            return {
                vicePresidents: ORGANIGRAMME_DATA.vicePresidents,
                conseilStrategique: ORGANIGRAMME_DATA.conseilStrategique,
                secretariat: ORGANIGRAMME_DATA.secretariat,
                tresorerie: ORGANIGRAMME_DATA.tresorerie,
                delegations: ORGANIGRAMME_DATA.delegations,
                cabinet: ORGANIGRAMME_DATA.cabinet,
                conseillers: ORGANIGRAMME_DATA.conseillers,
                hasResults: true
            };
        }

        const term = searchTerm.toLowerCase();

        // Filtrer vice-présidents
        const vicePresidents = ORGANIGRAMME_DATA.vicePresidents.filter(vp =>
            vp.nom.toLowerCase().includes(term)
        );

        // Filtrer conseil stratégique
        const conseilStrategique: {[key: string]: string[]} = {};
        Object.entries(ORGANIGRAMME_DATA.conseilStrategique).forEach(([province, membres]) => {
            const filteredMembers = membres.filter(membre =>
                membre.toLowerCase().includes(term) || province.toLowerCase().includes(term)
            );
            if (filteredMembers.length > 0 || province.toLowerCase().includes(term)) {
                conseilStrategique[province] = province.toLowerCase().includes(term) ? membres : filteredMembers;
            }
        });

        // Filtrer secrétariat
        const secretariat = {
            general: ORGANIGRAMME_DATA.secretariat.general.nom.toLowerCase().includes(term) ? ORGANIGRAMME_DATA.secretariat.general : null,
            adjoints: ORGANIGRAMME_DATA.secretariat.adjoints.filter(adj =>
                adj.nom.toLowerCase().includes(term) || adj.poste.toLowerCase().includes(term)
            )
        };

        // Filtrer trésorerie
        const tresorerie = {
            general: ORGANIGRAMME_DATA.tresorerie.general.nom.toLowerCase().includes(term) ? ORGANIGRAMME_DATA.tresorerie.general : null,
            adjoints: ORGANIGRAMME_DATA.tresorerie.adjoints.filter(adj =>
                adj.nom.toLowerCase().includes(term) || adj.poste.toLowerCase().includes(term)
            )
        };

        // Filtrer délégations
        const delegations: {[key: string]: string} = {};
        Object.entries(ORGANIGRAMME_DATA.delegations).forEach(([province, delegue]) => {
            if (province.toLowerCase().includes(term) || delegue.toLowerCase().includes(term)) {
                delegations[province] = delegue;
            }
        });

        // Filtrer cabinet
        const cabinet = {
            directeur: ORGANIGRAMME_DATA.cabinet.directeur.nom.toLowerCase().includes(term) ? ORGANIGRAMME_DATA.cabinet.directeur : null,
            adjoints: ORGANIGRAMME_DATA.cabinet.adjoints.filter(adj =>
                adj.nom.toLowerCase().includes(term) || adj.poste.toLowerCase().includes(term)
            ),
            rapporteurs: ORGANIGRAMME_DATA.cabinet.rapporteurs.filter(rap =>
                rap.nom.toLowerCase().includes(term) || rap.poste.toLowerCase().includes(term)
            ),
            secretaires: ORGANIGRAMME_DATA.cabinet.secretaires.filter(sec =>
                sec.nom.toLowerCase().includes(term) || sec.poste.toLowerCase().includes(term)
            )
        };

        // Filtrer conseillers
        const conseillers = ORGANIGRAMME_DATA.conseillers.filter(conseiller =>
            conseiller.nom.toLowerCase().includes(term) || conseiller.specialite.toLowerCase().includes(term)
        );

        const hasResults = vicePresidents.length > 0 ||
            Object.keys(conseilStrategique).length > 0 ||
            secretariat.general !== null || secretariat.adjoints.length > 0 ||
            tresorerie.general !== null || tresorerie.adjoints.length > 0 ||
            Object.keys(delegations).length > 0 ||
            cabinet.directeur !== null || cabinet.adjoints.length > 0 ||
            cabinet.rapporteurs.length > 0 || cabinet.secretaires.length > 0 ||
            conseillers.length > 0;

        return {
            vicePresidents,
            conseilStrategique,
            secretariat,
            tresorerie,
            delegations,
            cabinet,
            conseillers,
            hasResults
        };
    };

    const filteredData = getFilteredResults();

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white pt-16">
            {/* Header avec breadcrumb */}
            <div className="bg-white shadow-sm border-b">
                <div className="container mx-auto px-4 py-4">
                    <div className="flex items-center space-x-2 text-sm text-gray-500">
                        <a href="/" className="hover:text-primary-blue">Accueil</a>
                        <ChevronRight className="w-4 h-4" />
                        <span className="text-primary-blue font-medium">Organigramme</span>
                    </div>
                </div>
            </div>

            {/* Hero section */}
            <div className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <div
                        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                        style={{ backgroundImage: `url('/images/orgbg.webp')` }}
                    />
                    <div className="absolute inset-0 bg-primary-blue/75"></div>
                    <div className="absolute inset-0 bg-black/20"></div>
                </div>

                <div className="relative z-10 container mx-auto px-4 text-center text-white">
                    <div className="inline-flex items-center space-x-2 text-primary-yellow text-sm mb-6 bg-white/10 backdrop-blur-sm px-4 py-2 border border-white/20">
                        <Building2 className="w-4 h-4" />
                        <span className="font-medium">Structure Organisationnelle</span>
                    </div>

                    <h1 className="text-5xl md:text-6xl font-light text-white mb-6">
                        Organigramme UDB
                    </h1>

                    <div className="w-20 h-1 bg-primary-yellow mx-auto mb-8"></div>

                    <p className="text-xl text-white/90 font-light max-w-3xl mx-auto mb-12">
                        Découvrez la structure hiérarchique complète de l'Union Démocratique des Bâtisseurs
                        et ses instances dirigeantes
                    </p>

                    {/* Statistiques */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
                        <div className="bg-white/10 backdrop-blur-sm p-6 border border-white/20">
                            <div className="text-3xl font-bold text-white mb-2">{stats.totalVicePresidents}</div>
                            <div className="text-white/80 font-medium">Vice-Présidents</div>
                        </div>
                        <div className="bg-white/10 backdrop-blur-sm p-6 border border-white/20">
                            <div className="text-3xl font-bold text-white mb-2">{stats.totalConseilStrategique}</div>
                            <div className="text-white/80 font-medium">Conseil Stratégique</div>
                        </div>
                        <div className="bg-white/10 backdrop-blur-sm p-6 border border-white/20">
                            <div className="text-3xl font-bold text-white mb-2">{stats.totalDélégations}</div>
                            <div className="text-white/80 font-medium">Délégations</div>
                        </div>
                        <div className="bg-white/10 backdrop-blur-sm p-6 border border-white/20">
                            <div className="text-3xl font-bold text-white mb-2">{stats.totalConseillers}</div>
                            <div className="text-white/80 font-medium">Conseillers</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Section principale */}
            <section className="py-16 relative overflow-hidden">
                <div className="container mx-auto px-4 relative z-10">
                    <div className="max-w-7xl mx-auto">
                        {/* Barre de recherche */}
                        <div className="mb-12">
                            <div className="relative max-w-lg mx-auto">
                                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                                <input
                                    type="text"
                                    placeholder="Rechercher une personne ou un poste..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full pl-12 pr-12 py-4 border border-gray-400 focus:outline-none focus:border-primary-blue bg-white/95 backdrop-blur-sm text-base"
                                />
                                {searchTerm && (
                                    <button
                                        onClick={() => setSearchTerm('')}
                                        className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                                    >
                                        <X className="w-5 h-5" />
                                    </button>
                                )}
                            </div>
                        </div>

                        {filteredData.hasResults ? (
                            <div className="space-y-8">
                                {/* Vice-Présidents */}
                                {filteredData.vicePresidents.length > 0 && renderSection(
                                    'vicePresidents',
                                    'Vice-Présidents',
                                    <Crown className="w-6 h-6" />,
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {filteredData.vicePresidents.map((vp, index) => (
                                            <UniformPersonCard
                                                key={index}
                                                nom={vp.nom}
                                                poste="Vice-Président"
                                                isLeader={true}
                                            />
                                        ))}
                                    </div>,
                                    `${filteredData.vicePresidents.length} Vice-Présidents`
                                )}

                                {/* Conseil Stratégique National */}
                                {Object.keys(filteredData.conseilStrategique).length > 0 && renderSection(
                                    'conseilStrategique',
                                    'Conseil Stratégique National',
                                    <Shield className="w-6 h-6" />,
                                    <div className="space-y-6">
                                        {Object.entries(filteredData.conseilStrategique).map(([province, membres]) => (
                                            <div key={province}>
                                                <h4 className="text-lg font-semibold text-primary-blue mb-3 flex items-center">
                                                    <MapPin className="w-5 h-5 mr-2" />
                                                    {province}
                                                </h4>
                                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ml-7">
                                                    {membres.map((membre, idx) => (
                                                        <UniformPersonCard
                                                            key={idx}
                                                            nom={membre}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>,
                                    `Membres répartis dans les entités territoriales`
                                )}

                                {/* Secrétariat Général */}
                                {(filteredData.secretariat.general || filteredData.secretariat.adjoints.length > 0) && renderSection(
                                    'secretariat',
                                    'Secrétariat Général',
                                    <Briefcase className="w-6 h-6" />,
                                    <div className="space-y-6">
                                        {filteredData.secretariat.general && (
                                            <UniformPersonCard
                                                nom={filteredData.secretariat.general.nom}
                                                poste={filteredData.secretariat.general.poste}
                                                isLeader={true}
                                            />
                                        )}
                                        {filteredData.secretariat.adjoints.length > 0 && (
                                            <div>
                                                <h4 className="text-lg font-semibold text-gray-800 mb-3">Secrétaires Généraux Adjoints</h4>
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    {filteredData.secretariat.adjoints.map((adj, idx) => (
                                                        <UniformPersonCard
                                                            key={idx}
                                                            nom={adj.nom}
                                                            poste={adj.poste}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>,
                                    'Direction du Secrétariat Général'
                                )}

                                {/* Trésorerie Générale */}
                                {(filteredData.tresorerie.general || filteredData.tresorerie.adjoints.length > 0) && renderSection(
                                    'tresorerie',
                                    'Trésorerie Générale',
                                    <Award className="w-6 h-6" />,
                                    <div className="space-y-6">
                                        {filteredData.tresorerie.general && (
                                            <UniformPersonCard
                                                nom={filteredData.tresorerie.general.nom}
                                                poste={filteredData.tresorerie.general.poste}
                                                isLeader={true}
                                            />
                                        )}
                                        {filteredData.tresorerie.adjoints.length > 0 && (
                                            <div>
                                                <h4 className="text-lg font-semibold text-gray-800 mb-3">Trésoriers Généraux Adjoints</h4>
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                                    {filteredData.tresorerie.adjoints.map((adj, idx) => (
                                                        <UniformPersonCard
                                                            key={idx}
                                                            nom={adj.nom}
                                                            poste={adj.poste}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>,
                                    'Responsables des finances du parti'
                                )}

                                {/* Délégations Nationales */}
                                {Object.keys(filteredData.delegations).length > 0 && renderSection(
                                    'delegations',
                                    'Délégations Nationales',
                                    <MapPin className="w-6 h-6" />,
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                        {Object.entries(filteredData.delegations).map(([province, delegue]) => (
                                            <UniformPersonCard
                                                key={province}
                                                nom={delegue}
                                                poste={`Délégué National ${province}`}
                                                isLeader={true}
                                            />
                                        ))}
                                    </div>,
                                    'Délégués Nationaux par province'
                                )}

                                {/* Cabinet du Président */}
                                {(filteredData.cabinet.directeur || filteredData.cabinet.adjoints.length > 0 ||
                                        filteredData.cabinet.rapporteurs.length > 0 || filteredData.cabinet.secretaires.length > 0) &&
                                    renderSection(
                                        'cabinet',
                                        'Cabinet du Président Fondateur',
                                        <Building2 className="w-6 h-6" />,
                                        <div className="space-y-8">
                                            {filteredData.cabinet.directeur && (
                                                <div>
                                                    <h4 className="text-lg font-semibold text-gray-800 mb-3">Direction du Cabinet</h4>
                                                    <UniformPersonCard
                                                        nom={filteredData.cabinet.directeur.nom}
                                                        poste={filteredData.cabinet.directeur.poste}
                                                        isLeader={true}
                                                    />
                                                    {filteredData.cabinet.adjoints.length > 0 && (
                                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4 ml-4">
                                                            {filteredData.cabinet.adjoints.map((adj, idx) => (
                                                                <UniformPersonCard key={idx} nom={adj.nom} poste={adj.poste} />
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {filteredData.cabinet.rapporteurs.length > 0 && (
                                                <div>
                                                    <h4 className="text-lg font-semibold text-gray-800 mb-3">Rapporteurs</h4>
                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                                        {filteredData.cabinet.rapporteurs.map((rap, idx) => (
                                                            <UniformPersonCard key={idx} nom={rap.nom} poste={rap.poste} isLeader={idx === 0} />
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {filteredData.cabinet.secretaires.length > 0 && (
                                                <div>
                                                    <h4 className="text-lg font-semibold text-gray-800 mb-3">Secrétaires de Cabinet</h4>
                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                                        {filteredData.cabinet.secretaires.map((sec, idx) => (
                                                            <UniformPersonCard key={idx} nom={sec.nom} poste={sec.poste} isLeader={idx === 0} />
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>,
                                        'Structure opérationnelle du Président Fondateur'
                                    )}

                                {/* Conseillers Spéciaux */}
                                {filteredData.conseillers.length > 0 && renderSection(
                                    'conseillers',
                                    'Conseillers Spéciaux du Président',
                                    <UserCheck className="w-6 h-6" />,
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                        {filteredData.conseillers.map((conseiller, idx) => (
                                            <UniformPersonCard
                                                key={idx}
                                                nom={conseiller.nom}
                                                poste="Conseiller Spécial"
                                                specialite={conseiller.specialite}
                                            />
                                        ))}
                                    </div>,
                                    'Conseillers Spéciaux dans différents domaines'
                                )}
                            </div>
                        ) : (
                            <div className="text-center py-12">
                                <div className="w-16 h-16 bg-gray-100 flex items-center justify-center mx-auto mb-4">
                                    <Search className="w-8 h-8 text-gray-400" />
                                </div>
                                <h3 className="text-lg font-medium text-gray-900 mb-2">Aucun résultat trouvé</h3>
                                <p className="text-gray-500 mb-4">
                                    Aucune personne ou poste ne correspond à "<strong>{searchTerm}</strong>"
                                </p>
                                <button
                                    onClick={() => setSearchTerm('')}
                                    className="px-6 py-2 bg-primary-blue text-white hover:bg-primary-blue/90 transition-colors"
                                >
                                    Effacer la recherche
                                </button>
                            </div>
                        )}

                        {/* Call to Action */}
                        <div className="mt-16 bg-gradient-to-r from-primary-blue to-primary-green text-white p-8 border border-gray-400 text-center">
                            <h3 className="text-2xl font-bold mb-4">Rejoignez notre organisation</h3>
                            <p className="text-white/90 mb-6 max-w-2xl mx-auto">
                                L'UDB recrute des talents pour renforcer ses structures. Participez à la construction
                                du Gabon nouveau en rejoignant nos équipes !
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                                <button
                                    onClick={() => window.location.href = '/adhesion'}
                                    className="bg-white text-primary-blue px-8 py-3 font-semibold hover:bg-gray-100 transition-colors inline-flex items-center justify-center space-x-2 border border-gray-400"
                                >
                                    <Users className="w-5 h-5" />
                                    <span>Adhérer au parti UDB</span>
                                </button>
                                <button
                                    onClick={() => window.location.href = '/commissariat-politique'}
                                    className="border-2 border-white text-white px-8 py-3 font-semibold hover:bg-white hover:text-primary-blue transition-colors inline-flex items-center justify-center space-x-2"
                                >
                                    <Building2 className="w-5 h-5" />
                                    <span>Voir le Commissariat</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default OrganigrammePage;
